module.exports = __webpack_public_path__ + "2014c2e6587bc715ea340fbe2b8c6b74.svg";